var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 68,
    viewBox: "0 0 17 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 50.625C13.095 50.625 16.875 54.405 16.875 59.0625C16.875 63.72 13.095 67.5 8.4375 67.5C3.78 67.5 0 63.72 0 59.0625C0 54.405 3.78 50.625 8.4375 50.625ZM8.4375 25.3125C13.095 25.3125 16.875 29.0925 16.875 33.75C16.875 38.4075 13.095 42.1875 8.4375 42.1875C3.78 42.1875 0 38.4075 0 33.75C0 29.0925 3.78 25.3125 8.4375 25.3125ZM8.4375 0C13.095 0 16.875 3.78 16.875 8.4375C16.875 13.095 13.095 16.875 8.4375 16.875C3.78 16.875 0 13.095 0 8.4375C0 3.78 3.78 0 8.4375 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore);
export default __webpack_public_path__ + "static/media/ic_more.7ef5efa5700c6e25cf1895f3c53fa602.svg";
export { ForwardRef as ReactComponent };